import { QueryClientProvider } from '@tanstack/react-query'
import React from 'react'

import { onboardingQueryClient } from './queryClient'

export const OnboardingQueryProvider = ({ children }: { children: React.ReactNode }) => {
  return <QueryClientProvider client={onboardingQueryClient}>{children}</QueryClientProvider>
}
